import "./customerform.css";
import React, { useState } from "react";

// Encodes data for Netlify, safely handling arrays from checkbox groups
const encode = (data) => {
  return Object.keys(data)
    .map((key) => {
      const value = data[key];
      if (Array.isArray(value)) {
        return value
          .map((val) => encodeURIComponent(key) + "=" + encodeURIComponent(val))
          .join("&");
      }
      return encodeURIComponent(key) + "=" + encodeURIComponent(value);
    })
    .join("&");
};

export default function CustomerForm() {
  const [state, setState] = useState({
    "bot-field": "",
    yourName: "",
    email: "",
    phone: "",
    preferredContact: "",
    dogName: "",
    breed: "",
    age: "",
    weight: "",
    address: "",
    leashBehavior: "",
    requestedServices: [],
    additionalNotes: "",
    meetAndGreet: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setState((prev) => {
      let updatedValue = value;

      if (type === "checkbox") {
        updatedValue = checked;
      }

      return {
        ...prev,
        [name]: updatedValue,
      };
    });
  };

  const handleCheckboxGroupChange = (name, value, isChecked) => {
    setState((prev) => {
      const currentValues = prev[name] || [];
      if (isChecked) {
        return { ...prev, [name]: [...currentValues, value] };
      } else {
        return {
          ...prev,
          [name]: currentValues.filter((item) => item !== value),
        };
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Ensure at least one service is selected
    if (state.requestedServices.length === 0) {
      alert("Please select at least one service under 'Requested Services'.");
      return;
    }

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "customer-form", ...state }),
    })
      .then(() => setSubmitted(true))
      .catch((err) => alert(err));
  };

  if (submitted) {
    return (
      <div className="intake-wrap">
        <div className="intake-card fade-in-5">
          <div className="header-1">
            <a href="/" className="home-button-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#1f1f1f"
              >
                <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
              </svg>
            </a>
            <h1 className="header">Return Home</h1>
          </div>
          <h2 className="intake-title">Thanks! We received your form.</h2>
          <p className="intake-text">
            We’ll review it and follow up with you as soon as possible.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="header-1">
        <a href="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#1f1f1f"
          >
            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
          </svg>
        </a>
        <h1 className="header">New Customer Inquiry Form</h1>
      </div>
      <p className="intake-subtitle-1">
        Thank you for your interest! Please see the information and fill the
        form below.
      </p>
      <div className="intake-wrap">
        <form
          className="intake-form"
          name="customer-form"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value="customer-form" />

          <p className="sr-only">
            <label>
              Don’t fill this out:{" "}
              <input
                name="bot-field"
                value={state["bot-field"]}
                onChange={handleChange}
              />
            </label>
          </p>

          <header className="intake-header">
            <h2 className="header-services fade-in-5">Services</h2>
            <svg
              className="header-underline"
              viewBox="0 0 300 20"
              preserveAspectRatio="none"
            >
              <path
                d="M2,14 Q150,-6 220,4 Q260,9 298,"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
            <div className="services-containers">
              <h3 className="header-3">Lunch Walks - $35</h3>
              <ul className="services-list">
                <li>Monday - Friday 11:30 AM - 2:30 PM</li>
                <li>
                  Walks are 35 minutes long. (Often longer when weather and
                  scheduling permit)
                </li>
                <li>We also offer weekend walk drop-ins upon request</li>
                <li>Additional sibling dog $15</li>
              </ul>
            </div>
            <div className="services-containers">
              <h3 className="header-3">Lunch Potty Walks - $25</h3>
              <ul className="services-list">
                <li>Monday - Friday 11:30 AM - 2:30 PM</li>
              </ul>
            </div>
            <div className="services-containers">
              <h3 className="header-3">Overnight Boardings - $100</h3>
              {/* <p className="intake-subtitle fade-in-5">
                We usually provide full 1-on-1, crate-free boarding in our home,
                keeping group sizes strictly limited so your pup gets personal
                care. But will occasionally host two dogs at once if we know
                they get along wonderfully and will enjoy the company. Round
                trip pick-up and drop-off are included to fit your travel plans.
              </p> */}
              <ul className="services-list">
                <li>100% crate-free environment in a cozy home setting</li>
                <li>Small group capacity to ensure individual love and supervision</li>
                <li>Carefully matched playmates for dogs who enjoy friendly company</li>
                <li>Complimentary pick-up & drop-off included</li>
                <li>Additional sibling dog $50</li>
              </ul>
            </div>
            <div className="services-containers">
              <h3 className="header-3">Solo Overnight Boardings - $175</h3>
              <ul className="services-list">
                <li>Exclusive one-on-one care with no other dogs present</li>
                <li>Ideal for dogs who prefer individual attention or solitude</li>
                <li>Complimentary pick-up & drop-off included</li>
              </ul>
            </div>
            <br />
            <p className="intake-subtitle-2">
              No additional fees for holidays or weekends, ever.
            </p>
          </header>

          <Section title="Tell Us About Yourself and Your Dog">
            <div className="intake-grid">
              <Field
                label="Your Name"
                name="yourName"
                value={state.yourName}
                onChange={handleChange}
                required
              />
              <Field
                label="Email Address"
                name="email"
                type="email"
                value={state.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
              <Field
                label="Phone Number"
                name="phone"
                type="tel"
                value={state.phone}
                onChange={handleChange}
                placeholder="(555) 000-0000"
                required
              />
              <Select
                label="Preferred Contact Method"
                name="preferredContact"
                value={state.preferredContact}
                onChange={handleChange}
                required
                options={[
                  { label: "Email", value: "Email" },
                  { label: "Text Message", value: "Text Message" },
                  { label: "Phone Call", value: "Phone Call" },
                ]}
              />
              <Field
                label="Dog’s Name"
                name="dogName"
                value={state.dogName}
                onChange={handleChange}
                required
              />
              <Field
                label="Breed"
                name="breed"
                value={state.breed}
                onChange={handleChange}
                required
              />
              <Field
                label="Age"
                name="age"
                value={state.age}
                onChange={handleChange}
                required
              />
              <Field
                label="Weight"
                name="weight"
                value={state.weight}
                onChange={handleChange}
                placeholder="lbs or kg"
                required
              />
              <Field
                label="Address"
                name="address"
                value={state.address}
                onChange={handleChange}
                placeholder="Building Name or Street Address"
                required
              />
            </div>

            <p
              style={{
                marginTop: "-8px",
                marginBottom: "16px",
                fontSize: "0.9rem",
                color: "#555",
              }}
            >
              *We need your address to see if we serve in your area at the
              moment. No need to include apartment number.
            </p>

            <TextArea
              label="Any leash behavior to note (pulling, reactivity, fear, etc.)?"
              name="leashBehavior"
              value={state.leashBehavior}
              onChange={handleChange}
              rows={3}
            />
          </Section>

          <Section title="Requested Services">
            <div className="fade-in-5">
              <CheckboxGroup
                label="What kind of services are you looking for? (Select all that apply)"
                name="requestedServices"
                selectedValues={state.requestedServices}
                onChange={handleCheckboxGroupChange}
                required
                options={[
                  { label: "Lunch Walks", value: "Midday Lunch Walks" },
                  {
                    label: "Lunch Potty Walks",
                    value: "Lunch Potty Walks",
                  },
                  {
                    label: "Overnight Boardings",
                    value: "Overnight Boardings",
                  },
                  {
                    label: "Solo Overnight Boardings",
                    value: "Solo Overnight Boardings",
                  },
                ]}
              />
            </div>
          </Section>

          <Section title="Additional Notes">
            <TextArea
              label="Anything else you’d like us to know?"
              name="additionalNotes"
              value={state.additionalNotes}
              onChange={handleChange}
              rows={4}
            />
          </Section>

          <Section title="Schedule a Free Meet & Greet">
            <TextArea
              label="Please let us know your availability to schedule a free meet and greet."
              name="meetAndGreet"
              value={state.meetAndGreet}
              onChange={handleChange}
              rows={4}
            />
          </Section>

          <Section title="Our Care Policy">
            <ul className="intake-list">
              <li>
                Your dog is covered by our insurance during their walks or
                boardings.
              </li>
              <li>
                We prioritize safety, structure, and calm social interaction.
              </li>
            </ul>
          </Section>

          <button className="intake-submit" type="submit">
            Submit Form
          </button>
        </form>
      </div>
    </div>
  );
}

// ----------------------------------------------------
// HELPER COMPONENTS
// ----------------------------------------------------

function Section({ title, children }) {
  return (
    <section className="intake-section">
      <h2 className="intake-h2">{title}</h2>
      {children}
    </section>
  );
}

function Field({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  required,
  min,
}) {
  return (
    <label className="intake-label">
      <span className="intake-labeltext">
        {label}
        {required ? " *" : ""}
      </span>
      <input
        className="intake-input"
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        required={required}
        min={min}
        onChange={onChange}
      />
    </label>
  );
}

function Select({ label, name, value, onChange, options, required }) {
  return (
    <label className="intake-label">
      <span className="intake-labeltext">
        {label}
        {required ? " *" : ""}
      </span>
      <select
        className="intake-select"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
      >
        <option value="">Select contact preference...</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}

function TextArea({ label, name, value, onChange, rows = 3 }) {
  return (
    <label className="intake-label">
      <span className="intake-labeltext">{label}</span>
      <textarea
        className="intake-textarea"
        name={name}
        value={value}
        rows={rows}
        onChange={onChange}
      />
    </label>
  );
}

function CheckboxGroup({
  label,
  name,
  selectedValues,
  onChange,
  options,
  required,
}) {
  return (
    <fieldset style={{ border: "none", padding: 0, margin: "0 0 1rem 0" }}>
      <legend className="intake-labeltext" style={{ marginBottom: "8px" }}>
        {label}
        {required ? " *" : ""}
      </legend>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {options.map((opt) => (
          <label
            key={opt.value}
            className="intake-check"
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <input
              className="intake-checkbox"
              type="checkbox"
              name={name}
              value={opt.value}
              checked={selectedValues.includes(opt.value)}
              onChange={(e) => onChange(name, e.target.value, e.target.checked)}
            />
            <span className="intake-checktext">{opt.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
